import { isType } from './../actions/actions';
import { ReceiveUserFavouriteDataAction, UpdateUserFavouriteFetchDataStatusAction, UpsertUserFavouriteItemAction, DeleteUserFavouriteItemAction } from './../actions/userFavouriteActions';
import { initialUserFavouriteState, copyState } from '@src/State';
import { isApplication, isConsultingService, getFavouriteEntityState, upsertsUserFavouriteEntityState, deleteUserFavouriteEntityState } from './../utils/userFavouriteUtils';
import { Constants } from './../utils/constants';
export default function userFavouriteReducer(state = initialUserFavouriteState, action) {
    const newState = copyState(state);
    if (isType(action, ReceiveUserFavouriteDataAction)) {
        const payload = action.payload;
        const userFavourites = payload.userFavorites || [];
        userFavourites.forEach((userFavourite)=>{
            if (isApplication(userFavourite.applicationType)) {
                newState.apps = getFavouriteEntityState(userFavourite.favorites, userFavourite.applicationType);
            } else if (isConsultingService(userFavourite.applicationType)) {
                newState.services = getFavouriteEntityState(userFavourite.favorites, userFavourite.applicationType);
            }
        });
    } else if (isType(action, UpdateUserFavouriteFetchDataStatusAction)) {
        const payload = action.payload;
        if (newState.fetchDataStatus === payload.fetchDataStatus) {
            return state;
        }
        newState.fetchDataStatus = payload.fetchDataStatus;
    } else if (isType(action, UpsertUserFavouriteItemAction)) {
        if (newState.fetchDataStatus === Constants.UserFavourite.FetchDataStatus.Valid) {
            const payload = action.payload;
            if (isApplication(payload.applicationType)) {
                upsertsUserFavouriteEntityState(newState.apps, payload);
            } else if (isConsultingService(payload.applicationType)) {
                upsertsUserFavouriteEntityState(newState.services, payload);
            }
        }
    } else if (isType(action, DeleteUserFavouriteItemAction)) {
        if (newState.fetchDataStatus === Constants.UserFavourite.FetchDataStatus.Valid) {
            const payload = action.payload;
            if (isApplication(payload.applicationType)) {
                deleteUserFavouriteEntityState(newState.apps, payload);
            } else if (isConsultingService(payload.applicationType)) {
                deleteUserFavouriteEntityState(newState.services, payload);
            }
        }
    }
    return newState;
}
